import { Mail } from "lucide-react";
import { Separator } from "@/components/ui/separator";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { NewsletterReviewSpace } from "@/components/templates/NewsletterReviewSpace";
import { NewsletterSearch } from "@/components/templates/NewsletterSearch";
import { TopicManagement } from "@/components/templates/TopicManagement";
import { NewsletterTemplatesTab } from "@/components/templates/NewsletterTemplatesTab";

export const NewslettersTab = () => {
  return (
    <div className="space-y-6">
      <div className="flex items-center gap-2">
        <Mail className="h-5 w-5 text-primary" />
        <h2 className="text-2xl font-bold tracking-tight">Newsletters</h2>
      </div>
      
      <Separator />
      
      <Tabs defaultValue="review" className="space-y-4">
        <TabsList>
          <TabsTrigger value="review">Review</TabsTrigger>
          <TabsTrigger value="templates">Templates</TabsTrigger>
          <TabsTrigger value="topics">Topics</TabsTrigger>
          <TabsTrigger value="archive">Archive</TabsTrigger>
        </TabsList>

        <TabsContent value="review">
          <NewsletterReviewSpace />
        </TabsContent>

        <TabsContent value="templates">
          <NewsletterTemplatesTab />
        </TabsContent>

        <TabsContent value="topics">
          <TopicManagement />
        </TabsContent>

        <TabsContent value="archive">
          <NewsletterSearch />
        </TabsContent>
      </Tabs>
    </div>
  );
};